// Import order of the following files are important to prevent circular issues.
// Do NOT reorder/sort/change import and exports in this section.
// STRUCTURE IMPORTS
import FHIRObjectBase from './FHIRObjectBase';
import BaseElement from './structure/BaseElement';
import Element from './Element';
import BackboneElement from './BackboneElement';
import Resource from './Resource';
import DomainResource from './DomainResource';
// -------------------------------------------------------------
import BundleHandler from './transaction/BundleHandler';

// Import traits
import contactPointTraits from './trait/contactPointTraits';
import addressTraits from './trait/addressTraits';
import extensionTraits from './trait/extensionTraits';

// Import request handlers

// CONSTANTS
import { appointmentStatusValues, appointmentStatusDisplayValues, appointmentParticipantStatus } from './Appointment';
import { episodeOfCareStatusValues, episodeOfCareStatusDisplayValues } from './EpisodeOfCare';
import { episodeOfCareStatusHistoryStatusValues } from './EpisodeOfCareStatusHistory';
import { serviceRequestSystemStatusValues } from './ServiceRequest';
import { taskStatusValues, taskIntentValues, taskIntentDisplayValues, taskCodeTaskTypeValues, taskStatusDisplayValues } from './Task';
import { contactPointSystemValues, contactPointUseValues, contactEmailUseValues } from './trait/contactPointTraits';
import { addressUseValues, addressTypeValues } from './trait/addressTraits';
import { defaultBNExtensionStructureDefinitionUrlBase } from './Extension';

// Export all modules
export { default as FHIRObjectBase } from './FHIRObjectBase';
export { default as BaseElement } from './structure/BaseElement';
export { default as Extension } from './Extension';

export { default as extensionTraits } from './trait/extensionTraits';
export { default as Element } from './Element';
export { default as BackboneElement } from './BackboneElement';
export { default as Resource } from './Resource';
export { default as Narrative } from './Narrative';
export { default as DomainResource } from './DomainResource';

// -------------------------------------------------------------

export { default as AllowedX } from './types/AllowedX';
export { default as Annotation } from './types/Annotation';
export { default as AsNeededX } from './types/AsNeededX';
export { default as Attachment } from './types/Attachment';
export { default as Bundle } from './Bundle';
export { default as BundleEntry } from './BundleEntry';
export { default as BundleEntryRequest } from './BundleEntryRequest';
export { default as BundleEntryResponse } from './BundleEntryResponse';
export { default as BundleEntrySearch } from './BundleEntrySearch';
export { default as BundleLink } from './BundleLink';
export { default as ChargeItem } from './ChargeItem';
export { default as CodeableConcept } from './types/CodeableConcept';
export { default as CodeableReference } from './types/CodeableReference';
export { default as Coding } from './types/Coding';
export { default as DetailX } from './types/DetailX';
export { default as DiagnosisX } from './types/DiagnosisX';
export { default as Dosage } from './types/Dosage';
export { default as DosageDoseAndRate } from './types/DosageDoseAndRate';
export { default as DosageHold } from './types/DosageHold';
export { default as DoseX } from './types/DoseX';
export { default as Identifier } from './types/Identifier';
export { default as AdministrationVariance } from './types/AdministrationVariance';
export { default as IdentityVerification } from './types/IdentityVerification';
export { default as LimitOverride } from './types/LimitOverride';
export { default as MedicationAdministrationDosage } from './types/MedicationAdministrationDosage';
export { default as MedicationAdministrationPerformer } from './types/MedicationAdministrationPerformer';
export { default as MedicationX } from './types/MedicationX';
export { default as Money } from './types/Money';
export { default as OperationOutcome } from './OperationOutcome';
export { default as OperationOutcomeIssue } from './OperationOutcomeIssue';
export { default as Period } from './types/Period';
export { default as Quantity } from './types/Quantity';
export { default as Range } from './types/Range';
export { default as Reference } from './types/Reference';
export { default as ServicedX } from './types/ServicedX';
export { default as TaskRestriction } from './types/TaskRestriction';
export { default as Timing } from './types/Timing';
export { default as TimingRepeat } from './TimingRepeat';
export { default as UsedX } from './types/UsedX';
export { default as ValueX } from './types/ValueX';
export { default as LocationX } from './types/LocationX';

export { default as Signature } from './Signature';
export { default as createFhirResource } from './FhirResourceFactory';
export { default as contactPointTraits } from './trait/contactPointTraits';
export { default as addressTraits } from './trait/addressTraits';

export { default as Account } from './Account';
export { default as AccountCoverage } from './AccountCoverage';
export { default as AccountGuarantor } from './AccountGuarantor';
export { default as AdverseEvent } from './AdverseEvent';
export { default as Appointment } from './Appointment';
export { default as AppointmentParticipant } from './AppointmentParticipant';
export { default as AllergyIntolerance } from './AllergyIntolerance';
export { default as Address } from './Address';
export { default as BN_AuthRegister } from './BN_AuthRegister';
export { default as BN_AuthRegisterLedgerItem } from './BN_AuthRegisterLedgerItem';
export { default as BN_AuthorizationTemplate } from './BN_AuthorizationTemplate';
export { default as BN_Asam4Assessment } from './BN_Asam4Assessment';
export { default as BN_Asam4LevelOfCareCriteriaTerminology } from './BN_Asam4LevelOfCareCriteriaTerminology';
export { default as BN_CareTeamDepartment } from './BN_CareTeamDepartment';
export { default as BN_PatientRiskFlagConfig } from './BN_PatientRiskFlagConfig';
export { default as BN_VitalsConfig } from './BN_VitalsConfig';
export { default as BN_FaceSheetConfig } from './BN_FaceSheetConfig';
export { default as BN_EncounterType } from './BN_EncounterType';
export { default as BN_List } from './BN_List';
export { default as BN_ListItem } from './BN_ListItem';
export { default as BN_Relationship } from './BN_Relationship';
export { default as CarePlan } from './CarePlan';
export { default as CarePlanTarget } from './CarePlanTarget';
export { default as CareTeam } from './CareTeam';
export { default as CareTeamParticipant } from './CareTeamParticipant';
export { default as Claim } from './Claim';
export { default as ClaimResponse } from './ClaimResponse';
export { default as ClaimResponseItem } from './ClaimResponseItem';
export { default as ClaimResponseItemDetail } from './ClaimResponseItemDetail';
export { default as ClaimAccident } from './ClaimAccident';
export { default as ClaimCareTeam } from './ClaimCareTeam';
export { default as ClaimDiagnosis } from './ClaimDiagnosis';
export { default as ClaimInsurance } from './ClaimInsurance';
export { default as ClaimItem } from './ClaimItem';
export { default as ClaimPayee } from './ClaimPayee';
export { default as ClaimRelated } from './ClaimRelated';
export { default as ClinicalImpression } from './ClinicalImpression';
export { default as ClinicalImpressionFinding } from './ClinicalImpressionFinding';
export { default as ClinicalImpressionInvestigation } from './ClinicalImpressionInvestigation';
export { default as Condition } from './Condition';
export { default as ConditionStage } from './ConditionStage';
export { default as ConditionEvidence } from './ConditionEvidence';
export { default as Flag } from './Flag';
export { default as ContactDetail } from './ContactDetail';
export { default as ContactPoint } from './ContactPoint';
export { default as ContactPointSmsReminderConsent } from './ContactPointSmsReminderConsent';
export { default as Consent } from './Consent';
export { default as Coverage } from './Coverage';
export { default as CoverageClass } from './CoverageClass';
export { default as CoverageCostToBeneficiary } from './CoverageCostToBeneficiary';
export { default as CoverageCostToBeneficiaryException } from './CoverageCostToBeneficiaryException';
export { default as CoverageEligibilityRequest } from './CoverageEligibilityRequest';
export { default as CoverageEligibilityRequestInsurance } from './CoverageEligibilityRequestInsurance';
export { default as CoverageEligibilityRequestItem } from './CoverageEligibilityRequestItem';
export { default as CoverageEligibilityRequestItemDiagnosis } from './CoverageEligibilityRequestItemDiagnosis';
export { default as CoverageEligibilityRequestSupportingInfo } from './CoverageEligibilityRequestSupportingInfo';
export { default as CoverageEligibilityResponse } from './CoverageEligibilityResponse';
export { default as CoverageEligibilityResponseError } from './CoverageEligibilityResponseError';
export { default as CoverageEligibilityResponseInsurance } from './CoverageEligibilityResponseInsurance';
export { default as CoverageEligibilityResponseInsuranceItem } from './CoverageEligibilityResponseInsuranceItem';
export { default as CoverageEligibilityResponseInsuranceItemBenefit } from './CoverageEligibilityResponseInsuranceItemBenefit';
export { default as DocumentReference } from './DocumentReference';
export { default as Encounter } from './Encounter';
export { default as EncounterParticipant } from './EncounterParticipant';
export { default as EncounterDiagnosis } from './EncounterDiagnosis';
export { default as EncounterHospitalization } from './EncounterHospitalization';
export { default as EpisodeOfCare } from './EpisodeOfCare';
export { default as EpisodeOfCareStatusHistory } from './EpisodeOfCareStatusHistory';
export { default as EpisodeOfCareDiagnosis } from './EpisodeOfCareDiagnosis';
export { default as FamilyMemberHistory } from './FamilyMemberHistory';
export { default as Goal } from './Goal';
export { default as Group } from './Group';
export { default as HealthcareService } from './HealthcareService';
export { default as HealthcareServiceAddOn } from './HealthcareServiceAddOn';
export { default as HealthcareServiceModifier } from './HealthcareServiceModifier';
export { default as HealthcareServiceRevCode } from './HealthcareServiceRevCode';
export { default as HoursOfOperation } from './HoursOfOperation';
export { default as HumanName } from './HumanName';
export { default as List } from './List';
export { default as ListEntry } from './ListEntry';
export { default as Location } from './Location';
export { default as MeasurementSource } from './MeasurementSource';
export { default as MedicationStatement } from './MedicationStatement';
export { default as MedicationRequest } from './MedicationRequest';
export { default as MedicationAdministration } from './MedicationAdministration';
export { default as DuplicateReview } from './DuplicateReview';
export { default as Meta } from './Meta';
export { default as Observation } from './Observation';
export { default as ObservationComponent } from './ObservationComponent';
export { default as ObservationReferenceRange } from './ObservationReferenceRange';
export { default as Organization } from './Organization';
export { default as OrganizationContact } from './OrganizationContact';
export { default as Patient } from './Patient';
export { default as PatientCommunication } from './PatientCommunication';
export { default as Person } from './Person';
export { default as Position } from './Position';
export { default as Practitioner } from './Practitioner';
export { default as PractitionerQualification } from './PractitionerQualification';
export { default as PractitionerRole } from './PractitionerRole';
export { default as PractitionerRoleAccess } from './PractitionerRoleAccess';
export { default as Procedure } from './Procedure';
export { default as Provenance } from './Provenance';
export { default as ProvenanceEntity } from './ProvenanceEntity';
export { default as Questionnaire } from './Questionnaire';
export { default as QuestionnaireAnswerOption } from './QuestionnaireAnswerOption';
export { default as QuestionnaireInitialValue } from './QuestionnaireInitialValue';
export { default as QuestionnaireItem } from './QuestionnaireItem';
export { default as QuestionnaireItemEnableCondition } from './QuestionnaireItemEnableCondition';
export { default as QuestionnaireResponse } from './QuestionnaireResponse';
export { default as QuestionnaireResponseItem } from './QuestionnaireResponseItem';
export { default as QuestionnaireResponseItemAnswer } from './QuestionnaireResponseItemAnswer';
export { default as QuestionnaireResponseReviewer } from './QuestionnaireResponseReviewer';
export { default as RelatedPerson } from './RelatedPerson';
export { default as Role } from './Role';
export { default as ServiceRequest } from './ServiceRequest';
export { default as Task } from './Task';
export { default as UsageContext } from './UsageContext';
export { default as User } from './User';
export { default as ValueSet } from './ValueSet';
export { default as BN_Role } from './BN_Role';
export { default as BN_AccessGroup } from './BN_AccessGroup';
export { default as Communication } from './Communication';
export { default as CommunicationPayload } from './CommunicationPayload';
export { default as BN_MessageThread } from './BN_MessageThread';
export { default as BN_MessageThreadParticipant } from './BN_MessageThreadParticipant';
export { default as BN_MessageReaction } from './BN_MessageReaction';

export { default as BN_QuestionnaireField } from './BN_QuestionnaireField';
export { default as BN_SuperBill } from './BN_SuperBill';
export { default as BN_SuperBillInsurance } from './BN_SuperBillInsurance';
export { default as BN_SuperBillOccurenceCodeList } from './BN_SuperBillOccurenceCodeList';
export { default as BN_SuperBillOccurenceSpanCodeList } from './BN_SuperBillOccurenceSpanCodeList';
export { default as BN_SuperBillLineItem } from './BN_SuperBillLineItem';
export { default as BN_SuperBillLineItemDiagnosis } from './BN_SuperBillLineItemDiagnosis';
export { default as BN_SuperBillLineItemModifier } from './BN_SuperBillLineItemModifier';
export { default as BN_SuperBillLineItemAddOn } from './BN_SuperBillLineItemAddOn';
export { default as BN_SuperBillProcedureCode } from './BN_SuperBillProcedureCode';
export { default as BN_SuperBillValueCodeList } from './BN_SuperBillValueCodeList';
export { default as BN_FinancialClass } from './BN_FinancialClass';
export { default as BN_Payment } from './BN_Payment';
export { default as BN_PostPayment } from './BN_PostPayment';
export { default as BN_LedgerTransaction } from './BN_LedgerTransaction';
export { default as BN_PatientLedgerEntry } from './BN_PatientLedgerEntry';
export { default as BN_MedPassDose } from './BN_MedPassDose';
export { default as BN_MedPassPrep } from './BN_MedPassPrep';
export { default as BN_MedPassDay } from './BN_MedPassDay';

export { default as BN_PayorAddress } from './BN_PayorAddress';
export { default as BN_PayorChecklist } from './BN_PayorChecklist';
export { default as BN_File } from './BN_File';
export { default as BN_PatientAccountSummary } from './BN_PatientAccountSummary';

export { default as BN_TreatmentPlanLibraryCategory } from './BN_TreatmentPlanLibraryCategory';
export { default as BN_TreatmentPlanLibraryGoal } from './BN_TreatmentPlanLibraryGoal';
export { default as BN_TreatmentPlanLibraryObjective } from './BN_TreatmentPlanLibraryObjective';

export const constants = {
    appointmentStatusValues,
    appointmentStatusDisplayValues,
    appointmentParticipantStatus,
    episodeOfCareStatusValues,
    episodeOfCareStatusDisplayValues,
    episodeOfCareStatusHistoryStatusValues,
    serviceRequestSystemStatusValues,
    defaultBNExtensionStructureDefinitionUrlBase,
    taskStatusValues,
    taskIntentValues,
    taskCodeTaskTypeValues,
    taskStatusDisplayValues,
    taskIntentDisplayValues,
    contactPointSystemValues,
    contactPointUseValues,
    contactEmailUseValues,
    addressUseValues,
    addressTypeValues,
};

export const structure = {
    BaseElement,
    BackboneElement,
    DomainResource,
    FHIRObjectBase,
    Element,
    Resource,
};

export const request = {
    BundleHandler,
};

export const traits = {
    contactPointTraits,
    addressTraits,
    extensionTraits,
};
